module.exports = __webpack_public_path__ + "static/3-8bd1e10460e7603ce1fdc78b99199d96.jpg";